import { useCallback } from "react"

import {
	acriss,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	prepaid,
	priceKpi,
	providers,
	reports,
	repricingPass,
	searchID,
	sites,
	transmission
} from "@signals"
import { dorSchema } from "../schema"
import { useToast } from "@hooks"
import { tableHasMainComparison, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { analyzerRequest } from "Pages/AnalyzersV2/@services/analyzerRequestApp"
import { useValidatorSeeker } from "@app"
import { dorPayload } from "Pages/AnalyzersV2/Dor/@signals"
import { loadPassDecisions } from "Pages/AnalyzersV2/@services/decisionsApi"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerDorFilters() {
	const { showToast } = useToast()
	const { isValid, errors } = useValidatorSeeker(dorPayload.value, dorSchema(searchID.value))

	// `keep` (a car picked, Min / Max; CU-869fmpqfm C1): the table stays under "Updating…" and nothing is reset
	const onSubmit = useCallback((clearTab = false, { keep = false } = {}) => {
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		const payload = dorPayload.value
		analyzerRequest.run({
			payload, type: SECTIONS.DOR, keep, clearTab,
			onError: () => showToast.error(),
			// the engine's decisions on the cells, only with a pass (CU-869fmm949)
			after: () => { if (repricingPass.value) loadPassDecisions(payload) },
		})
	}, [
		currency.value, offices.value, tableTabSelected.value, acriss.value,
		transmission.value, categories.value, fuelPolicy.value, lengthRental.value,
		providers.value, prepaid.value, mileage.value, priceKpi.value, inTerminal.value,
		insurance.value, includeProviders.value, sites.value, reports.value, repricingPass.value, isValid
	])

	return {
		onSubmit: onSubmit,
		isValid: (isValid && (!!reports.value || !!repricingPass.value)) || !!searchID.value,
		errors: errors
	}
}